import React, { useContext } from 'react'

import StarIcon from './StarIcon';
import {
  TYPE_FAVOURITE_LISTINGS,
  TYPE_FAVOURITE_PRODUCTS,
} from '../contexts/Favourites';
import { FavouritesContext } from '../contexts/index.jsx'

const Star = ({ item, type = TYPE_FAVOURITE_LISTINGS, className = '' }) => {
    const favourites = useContext(FavouritesContext)

    const starred = favourites.find(item, type);

    const toggleStar = (e) => {
        e.preventDefault();

        if (starred) {
            favourites.remove(item, type);
        } else {
            favourites.add(item, type);
        }
    }

    const iconClassName = type === TYPE_FAVOURITE_PRODUCTS ?
      'product-icon' :
      '';

    return (
      <StarIcon
        active={starred}
        onClick={toggleStar}
        iconClassName={iconClassName}
        className={className}
      />
    );
};

export default Star
